import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletAccountRequestOtpCollectionResponse } from '../../../data/repository/fs-wallet-account/http-fs-wallet-account.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletAccountRepository } from '../../repository/fs-wallet-account.repository';
import { OtpRequestDTO } from './interface/otp-request.dto';

@Injectable({
  providedIn: 'root',
})
export class RequestWalletOtpUsecase
  implements
    UseCase<OtpRequestDTO, HttpWalletAccountRequestOtpCollectionResponse>
{
  constructor(private repository: FSWalletAccountRepository) {}

  execute(
    data: OtpRequestDTO
  ): Observable<HttpWalletAccountRequestOtpCollectionResponse> {
    return this.repository.RequestWalletOtp(data);
  }
}
